module.exports = __webpack_public_path__ + "img/Capture1.061414cb.jpg";